<template>
  <div class="product-page">
    <ProductHeader
      :isSticky="!isUpScroll"
      :totalCount="totalCount"
      :productName="categoryInfo.CategoryName"
      :productDescription="categoryInfo.Description"
      @menu-open="onMenuOpen"
      @menu-close="onMenuClose"
    >
      <!-- 第一组产品 -->
      <div class="product-grid">
        <div class="grid-item large-item">
          <ProgressiveImage :src="decorativeImageList[0] || categoryInfo.DecorativeImage || largeImg1"
            alt="Lifestyle" />
        </div>

        <div class="grid-item product-item" :class="{ 'has-content': !item.isPlaceholder }"
          v-for="(item, index) in initialProducts.slice(0, 6)" :key="'top-' + index">
          <div v-if="!item.isPlaceholder"
               class="product-image-wrapper"
               :class="{ 'origin-left': index === 2 || index === 3 }"
               @click="openDetail(item)">
            <ProgressiveImage :src="item.MainImage" alt="Product" customClass="product-thumb" />
            <img v-if="item.hoverSrc" :src="item.hoverSrc" alt="Gallery" class="gallery-image" />
            <div class="product-name-overlay">{{ item.ProductName }}</div>
          </div>
          <!-- ★ 修改1：占位格显示 bq.jpg -->
          <div v-else class="product-image-wrapper placeholder-wrapper">
            <img :src="placeholderImage" alt="Placeholder" class="product-thumb" />
          </div>
        </div>

        <div class="grid-item product-item" :class="{ 'has-content': !item.isPlaceholder }"
          v-for="(item, index) in initialProducts.slice(6, 10)" :key="'bottom-' + index">
          <div v-if="!item.isPlaceholder"
               class="product-image-wrapper"
               :class="{ 'origin-left': index < 2 }"
               @click="openDetail(item)">
            <ProgressiveImage :src="item.MainImage" alt="Product" customClass="product-thumb" />
            <img v-if="item.hoverSrc" :src="item.hoverSrc" alt="Gallery" class="gallery-image" />
            <div class="product-name-overlay">{{ item.ProductName }}</div>
          </div>
          <!-- ★ 修改2：占位格显示 bq.jpg -->
          <div v-else class="product-image-wrapper placeholder-wrapper">
            <img :src="placeholderImage" alt="Placeholder" class="product-thumb" />
          </div>
        </div>
      </div>

      <!-- 更多产品组 -->
      <div class="product-grid" v-for="(group, groupIndex) in additionalProductGroups"
        :key="'group-' + groupIndex">
        <div class="grid-item large-item" :class="{ 'right-side': (groupIndex + 1) % 2 !== 0 }">
          <ProgressiveImage :src="getDecorativeImageForGroup(groupIndex) || largeImg" alt="Lifestyle" />
        </div>

        <div class="grid-item product-item" :class="{ 'has-content': !item.isPlaceholder }"
          v-for="(item, index) in group.slice(0, 6)"
          :key="'group-top-' + groupIndex + '-' + index">
          <div v-if="!item.isPlaceholder"
               class="product-image-wrapper"
               :class="{ 'origin-left': (groupIndex % 2 === 0 ? index < 4 : (index === 2 || index === 3)) }"
               @click="openDetail(item)">
            <ProgressiveImage :src="item.MainImage" alt="Product" customClass="product-thumb" />
            <img v-if="item.hoverSrc" :src="item.hoverSrc" alt="Gallery" class="gallery-image" />
            <div class="product-name-overlay">{{ item.ProductName }}</div>
          </div>
          <!-- ★ 修改3：占位格显示 bq.jpg -->
          <div v-else class="product-image-wrapper placeholder-wrapper">
            <img :src="placeholderImage" alt="Placeholder" class="product-thumb" />
          </div>
        </div>

        <div class="grid-item product-item" :class="{ 'has-content': !item.isPlaceholder }"
          v-for="(item, index) in group.slice(6, 10)"
          :key="'group-bottom-' + groupIndex + '-' + index">
          <div v-if="!item.isPlaceholder"
               class="product-image-wrapper"
               :class="{ 'origin-left': index < 2 }"
               @click="openDetail(item)">
            <ProgressiveImage :src="item.MainImage" alt="Product" customClass="product-thumb" />
            <img v-if="item.hoverSrc" :src="item.hoverSrc" alt="Gallery" class="gallery-image" />
            <div class="product-name-overlay">{{ item.ProductName }}</div>
          </div>
          <!-- ★ 修改4：占位格显示 bq.jpg -->
          <div v-else class="product-image-wrapper placeholder-wrapper">
            <img :src="placeholderImage" alt="Placeholder" class="product-thumb" />
          </div>
        </div>
      </div>

      <Footer layout="about" :show-general-enquires="true" :show-studio="true" :show-instagram="true" />
    </ProductHeader>
  </div>
</template>

<script>
import ProductHeader from '@/components/productHeader.vue'
import Footer from '@/components/Footer.vue'
import ProgressiveImage from '@/components/ProgressiveImage.vue'
import { getCategoryDetail } from '@/api/product'

const largeImg1 = require('@/assets/product/TGT-Melissa-Marshall-27 1.jpg')
const largeImg = require('@/assets/_DSC0544 2 3-1.png')
const lk = require('@/assets/bq.jpg')

export default {
  name: 'ProductPage',
  components: { ProductHeader, Footer, ProgressiveImage },
  data() {
    return {
      isUpScroll: true,
      lastScrollY: 0,
      largeImg1,
      largeImg,
      categoryInfo: {},
      initialProducts: [],
      additionalProductGroups: [],
      totalCount: 0,
      isMobile: false,
      isMenuOpen: false,
      // ★ 新增：占位图
      placeholderImage: lk,
    }
  },
  computed: {
    decorativeImageList() {
      const images = []
      const keys = ['DecorativeImage']
      for (let i = 2; i <= 15; i++) {
        keys.push(`DecorativeImage${i}`)
      }
      for (const key of keys) {
        const url = this.categoryInfo[key]
        if (url && typeof url === 'string' && url.trim() !== '') {
          images.push(url)
        }
      }
      return images
    }
  },
  watch: {
    '$route.query.CategoryID': {
      handler() { this.fetchCategoryDetail() },
      immediate: true
    }
  },
  mounted() {
    this.isMobile = window.innerWidth < 768
    window.addEventListener('resize', this.handleResize)

    // 监听菜单事件
    this.$root.$on('menu-opened', this.onMenuOpened)
    this.$root.$on('menu-closed', this.onMenuClosed)

    this.lastScrollY = window.scrollY
    window.addEventListener('scroll', this.handleScroll, { passive: true })
    window.addEventListener('wheel', this.handleWheel, { passive: true })
  },
  beforeDestroy() {
    this.$root.$off('menu-opened', this.onMenuOpened)
    this.$root.$off('menu-closed', this.onMenuClosed)
    window.removeEventListener('resize', this.handleResize)
    window.removeEventListener('scroll', this.handleScroll)
    window.removeEventListener('wheel', this.handleWheel)
  },
  methods: {
    // ★ 滚动到顶部
    scrollToTop() {
      window.scrollTo({ top: 0, behavior: 'smooth' })
    },

    // ---------- 菜单事件处理 ----------
    onMenuOpened() {
      this.isMenuOpen = true
    },
    onMenuClosed() {
      this.isMenuOpen = false
      this.lastScrollY = window.scrollY
      this.handleScroll()
    },

    // ---------- 滚动事件 ----------
    handleScroll() {
      if (this.isMenuOpen) return
      const currentScroll = window.scrollY
      const delta = currentScroll - this.lastScrollY
      if (delta > 0) {
        this.isUpScroll = false
      } else if (delta < 0) {
        this.isUpScroll = true
      }
      this.lastScrollY = currentScroll
    },

    handleWheel(e) {
      if (this.isMenuOpen) return
      const deltaY = e.deltaY
      const currentScroll = window.scrollY
      if (deltaY > 0) {
        this.isUpScroll = false
      } else if (deltaY < 0) {
        this.isUpScroll = true
      }
      this.lastScrollY = currentScroll
    },

    // ---------- 业务方法 ----------
    handleResize() {
      this.isMobile = window.innerWidth < 768
    },
    onMenuOpen() {},
    onMenuClose() {},
    getCategoryIdFromRoute() {
      const raw = this.$route.query.CategoryID
      if (raw === undefined || raw === null) return null
      const parsed = Number(raw)
      return isNaN(parsed) ? null : parsed
    },
    padArray(arr, size, fill) {
      const result = [...arr]
      while (result.length < size) {
        result.push(fill)
      }
      return result
    },
    async fetchCategoryDetail() {
      this.initialProducts = []
      this.additionalProductGroups = []
      const categoryId = this.getCategoryIdFromRoute()
      if (categoryId === null) return
    
      try {
        const device = this.isMobile ? 'mobile' : 'pc'
        const response = await getCategoryDetail(categoryId, device)
        const data = response.result || response
        this.categoryInfo = data
        this.totalCount = data.ProductCount || 0
    
        const products = (data.Products || []).map(p => ({
          ...p,
          hoverSrc: p.GalleryImage || p.BigImage || p.MainImage || ''
        }))
    
        const placeholder = { isPlaceholder: true }
        const total = products.length
    
        if (total <= 6) {
          // ★ 产品 ≤ 6：显示一组，补齐到 6 个
          this.initialProducts = this.padArray(products.slice(0), 6, placeholder)
          this.additionalProductGroups = []
        } else {
          // 产品 > 6：第一组取前10个，补位到10；后续组每10个一组，最后一组补到6
          const firstGroup = products.slice(0, 10)
          this.initialProducts = this.padArray(firstGroup, 10, placeholder)
    
          const rest = products.slice(10)
          const rawGroups = []
          for (let i = 0; i < rest.length; i += 10) {
            rawGroups.push(rest.slice(i, i + 10))
          }
          this.additionalProductGroups = rawGroups.map((group, idx) => {
            const isLast = idx === rawGroups.length - 1
            const targetSize = isLast ? 6 : 10
            return this.padArray(group, targetSize, placeholder)
          })
        }
    
        if (categoryId === 0 || categoryId === 999) {
          this.categoryInfo = {
            ...this.categoryInfo,
            CategoryName: data.CategoryName,
            Description: data.Description
          }
        }
    
        this.$nextTick(() => {
          this.scrollToTop()
        })
      } catch (error) {
        console.error('Failed to load products:', error)
      }
    },
    getDecorativeImageForGroup(groupIndex) {
      const list = this.decorativeImageList
      if (list.length === 0) return null
      const idx = (groupIndex + 1) % list.length
      return list[idx]
    },
    openDetail(product) {
      this.$router.push({
        path: '/product/detail',
        query: { productId: product.ProductID }
      })
    }
  }
}
</script>

<style scoped>
.product-page {
  width: 100%;
  min-height: 100vh;
  background-color: #fff;
}

.product-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  width: 100%;
  border-left: 0.25rem solid #000;
}
.product-grid:first-child {
  border-top: 0.25rem solid #000;
}
.grid-item {
  position: relative;
  overflow: hidden;
  width: 100%;
  box-sizing: border-box;
}
.grid-item img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}
.large-item {
  grid-column: span 2;
  grid-row: span 3;
  width: 100%;
  background-color: #f5f5f5;
  border-right: 1rem solid #000 !important;
  border-bottom: 1rem solid #000 !important;
  aspect-ratio: 2 / 3;
}
.product-item {
  grid-column: span 1;
  grid-row: span 1;
  border-right: 0.25rem solid #000 !important;
  border-bottom: 0.25rem solid #000 !important;
  background-color: #fafafa;
  aspect-ratio: 1 / 1;
}
.product-item.has-content:hover {
  border-right: 2rem solid #000 !important;
  border-bottom: 2rem solid #000 !important;
  border-top: 1rem solid #000 !important;
  border-left: 1rem solid #000 !important;
}

.product-image-wrapper {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
  transform-origin: right center;
  cursor: pointer;
}
.product-image-wrapper.origin-left {
  transform-origin: left center;
}
.placeholder-wrapper {
  pointer-events: none;
}

.gallery-image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  opacity: 0;
  pointer-events: none;
  z-index: 1;
  transition: opacity 0.3s ease;
}
.product-image-wrapper:hover .gallery-image {
  opacity: 1;
}

.product-name-overlay {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #ffffff;
  font-size: 16rem;
  font-weight: 500;
  text-align: center;
  z-index: 2;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.3s ease;
  padding: 0 1rem;
  white-space: nowrap;
  font-family: 'Apercu-Medium', sans-serif;
}
.product-image-wrapper:hover .product-name-overlay {
  opacity: 1;
}

.product-info-bar {
  display: none;
}

@media (min-width: 1025px) {
  .large-item.right-side {
    grid-column: 3 / span 2;
    grid-row: 1 / span 3;
  }
}
@media (max-width: 1024px) {
  .product-grid {
    grid-template-columns: repeat(2, 1fr);
  }
  .large-item {
    grid-column: span 2;
    grid-row: auto;
    aspect-ratio: 16 / 9;
  }
  .product-item {
    grid-column: span 1;
    aspect-ratio: 1 / 1;
  }
  .product-name-overlay {
    font-size: 14rem;
  }
}
@media (max-width: 768px) {
  .product-grid {
    grid-template-columns: 1fr;
  }
  .large-item {
    grid-column: span 1;
    aspect-ratio: 4 / 3;
  }
  .product-item {
    grid-column: span 1;
    aspect-ratio: 1 / 1;
  }
  .product-name-overlay {
    font-size: 12rem;
  }
}
</style>